import { UserState } from '../Reducers'
import { UserAction } from './UserActions'
import { UserActionType } from './UserActionTypes'

const INITIAL_STATE: UserState = {
	balance: {},
	kycUpdateRequestInProgress: false,
	personalInfoFetchRequestInProgress: false,
	userInfo: {},
	verificationInfo: { idStatus: 'UNVERIFIED', },
	blockPurchaseUntilRefresh: false,
}

export const userReducer = (state: UserState = INITIAL_STATE, action: UserAction): UserState => {
	switch (action.type) {
	case UserActionType.PERSONAL_INFO_UPDATED: {
		return {
			...state ,
			kycUpdateRequestInProgress: false ,
			userInfo: {...state.userInfo , kycInfoUpdated: true} ,
		}
	}
	case UserActionType.KYC_FORM_UPDATED: {
		return {
			...state,
			addressInfo : {...state.addressInfo, country: action.payload },
		}
	}
	case UserActionType.REQUEST_PERSONAL_INFO_UPDATE : {
		return { ...state, userInfo: { ...state.userInfo}, kycUpdateRequestInProgress: true }
	}
	case UserActionType.RECEIVE_USER_BALANCE: {
		return { ...state, balance: action.payload }
	}
	case UserActionType.RECEIVE_USER_INFO: {
		if (action.payload.kycVerified) {
			return { ...state, userInfo: action.payload, verificationInfo: { idStatus: 'VERIFIED' }}
		}
		return { ...state, userInfo: action.payload }
	}
	case UserActionType.RECEIVE_PERSONAL_INFO : {
		return {...state , personalInfo: action.payload, personalInfoFetchRequestInProgress: false}
	}
	case UserActionType.REQUEST_PERSONAL_INFO : {
		return {...state , personalInfoFetchRequestInProgress: true}
	}
	case UserActionType.RECEIVE_ID_VERIFICATION_STATUS : {
		let idStatus: IdStatus = 'UNVERIFIED'
		if (state.userInfo.kycVerified) {
			idStatus = 'VERIFIED'
		} else if (action.payload.pendingStatus) {
			idStatus = 'PENDING'
		}
		return {...state, verificationInfo: { idStatus }}
	}
	case UserActionType.LOGIN_COMPLETED : {
		return { ...state, loginCompleted: true }
	}
	case UserActionType.BLOCK_PURCHASE_UNTIL_REFRESH : {
		return { ...state, blockPurchaseUntilRefresh: true }
	}
	case UserActionType.RESET_BLOCK_PURCHASE_UNTIL_REFRESH: {
		return { ...state, blockPurchaseUntilRefresh: false }
	}
	default:
		// Assert never is used to ensure that every known cashout action is handled by the switch-case.
		const assertNever: never = action
		return state
	}
}
